import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Oranienburg() {
  return (
    <LocationPageTemplate
      page={{
        location: "Oranienburg",
        locationSlug: "oranienburg",
        keyword: "Haushaltsauflösung Oranienburg",
        metaTitle:
          "Haushaltsauflösung Oranienburg | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung in Oranienburg. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung anfragen!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Oranienburg – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb899b8820448a9a40.jpg",
        localIntro: (
          <>
            <p>
              Oranienburg, nördlich von Berlin gelegen, ist eine wachsende Stadt
              mit einer Mischung aus historischen Gebäuden im Zentrum, großen
              Wohnsiedlungen und weitläufigen Einfamilienhausgebieten in den
              Ortsteilen wie Sachsenhausen oder Lehnitz. Diese Struktur bringt
              bei Haushaltsauflösungen unterschiedliche Anforderungen mit sich.
            </p>
            <p>
              Während in der Innenstadt oft Wohnungen in Mehrfamilienhäusern
              geräumt werden, geht es in den Randlagen häufig um die komplette
              Auflösung von Grundstücken, inklusive Kellern, Garagen und
              Nebengelassen.
            </p>
            <p>
              Wir sind regelmäßig in Oranienburg im Einsatz und bieten Ihnen
              unseren bewährten Service: Von der kostenlosen Besichtigung bis
              zur besenreinen Übergabe, alles aus einer Hand und zum
              garantierten Festpreis.
            </p>
          </>
        ),
        trustText:
          "Ob eine Wohnung im Stadtzentrum oder ein Einfamilienhaus in Lehnitz – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen zuverlässig zur Seite.",
        trustQuote:
          "Sehr gute Arbeit bei der Haushaltsauflösung in Oranienburg. Pünktlich, sauber und genau zum vereinbarten Preis.",
        challengesText: (
          <>
            <p>
              Bei der Räumung von Grundstücken mit Nebengebäuden bringen wir bei
              Bedarf auch größeres Gerät oder Container zum Einsatz, um die
              Arbeiten zügig abzuschließen. Die fachgerechte Trennung und
              Entsorgung auf den lokalen Recyclinghöfen (AWU) ist dabei immer
              inklusive.
            </p>
            <p>
              In den dichter bebauten Bereichen kümmern wir uns im Vorfeld um
              die Beantragung und Aufstellung von Halteverbotsschildern, um
              einen reibungslosen Abtransport zu gewährleisten.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Das Team hat unser Haus in Sachsenhausen sehr schnell und ordentlich entrümpelt. Toller Service!",
            author: "Kunde aus Sachsenhausen",
          },
          {
            text: "Sehr freundlich und professionell. Die Wertanrechnung war sehr fair.",
            author: "Kundin aus der Innenstadt",
          },
          {
            text: "Alles wurde besenrein hinterlassen, genau wie versprochen. Keine versteckten Kosten.",
            author: "Familie aus Lehnitz",
          },
        ],
        neighbors: [
          { name: "Oberhavel", slug: "oberhavel" },
          { name: "Reinickendorf", slug: "reinickendorf" },
          { name: "Pankow", slug: "pankow" },
        ],
        faqs: [
          {
            q: "Kommen Sie für eine Besichtigung nach Oranienburg?",
            a: "Ja, wir bieten kostenlose und unverbindliche Besichtigungstermine im gesamten Stadtgebiet an.",
          },
          {
            q: "Entrümpeln Sie auch Garagen und Schuppen?",
            a: "Selbstverständlich. Wir räumen komplette Grundstücke inklusive aller Nebengebäude, Keller und Dachböden.",
          },
          {
            q: "Wie lange dauert eine Haushaltsauflösung in der Regel?",
            a: "Eine normale Wohnungsauflösung ist oft an einem Tag erledigt. Bei größeren Häusern planen wir entsprechend mehr Zeit ein.",
          },
          {
            q: "Nehmen Sie auch alte Elektrogeräte mit?",
            a: "Ja, wir entsorgen alle Arten von Hausrat fachgerecht, einschließlich Elektro-Großgeräten.",
          },
        ],
      }}
    />
  );
}
